import { render, staticRenderFns } from "./activityEdit.vue?vue&type=template&id=e2b91790&scoped=true"
import script from "./activityEdit.vue?vue&type=script&lang=js"
export * from "./activityEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b91790",
  null
  
)

export default component.exports